import { handleImgSize } from '@/common/utils/map_view_data'

export const getSmallPlanar = url => url ? handleImgSize(url, 750, 600) + '/quality,Q_30' : ''
export const getLargePlanar = url => url ? url + '?x-oss-process=image/format,jpg' : ''